import React from 'react';
import classnames from 'classnames';

import styles from './index.css';

const Hamburger = ({ open }) => (
	<div
		className={classnames(styles.hamburger, {
			[styles.open]: open,
		})}
	>
		<span className={styles.line} />
		<span className={styles.line} />
		<span className={styles.line} />
	</div>
);

export default Hamburger;



// WEBPACK FOOTER //
// ./src/components/atoms/Hamburger/index.js